import React, { Component } from "react";

export default class DemandDetail extends Component {
  render() {
    const { demand } = this.props;
    return (
      <div className="modal fade " id={"modal" + demand.talepNo} tabIndex="-1">
        <div className="modal-dialog modal-dialog-scrollable">
        <div>
        <div className="t-modalAreaDemandDetail" >
            <div
              className="t-modalContentDemandDetail "
              id="id-modalDemandDetail"
              style={(window.innerWidth<=900)?{width:"89%"}: {width:"40%"}}
            >
              <div
                className="t-modalDemandDetail"
                id="id-modalGenel"
                style={{ backgroundColor: "rgb(255, 255, 255)" }}
              >
                <div className="container-fluid">
                  <div className="row t-modalHeaderDemandDetail ">
                    <div
                      className="col"
                      id="id-modalHeader"
                      style={{ color: "rgb(153, 153, 153)" }}
                    >
                      Talep No: <strong>{demand?.talepNo}</strong>
                    </div>
                    <div className="col-auto t-cursorPointer" data-dismiss="modal">
                      <i
                        className="t-icon-cross"
                        id="id-modalHeaderIcon"
                        style={{ color: "rgb(153, 153, 153)" }}
                      />
                    </div>
                  </div>
                  <div className="row t-modalBodyDemandDetail ">
                    <div
                      className="col-12"
                      id="id-modalBody"
                      style={{ color: "rgb(153, 153, 153)" }}
                    >
                      <div>
                        <table className="table table-sm t-tablo text-left">
                          <tbody>
                            <tr>
                              <th scope="row" >
                                Talep Durumu :
                              </th>
                              <td>{demand?.durumu}</td>
                            </tr>
                            <tr>
                              <th scope="row" >
                                Açılma Tarihi :
                              </th>
                              <td>
                                {new Date(demand?.acilisTarihi).toLocaleDateString()}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row" >
                                Kapanma Tarihi :
                              </th>
                              <td>
                                {demand?.kapanisTarihi !== "0001-01-01T00:00:00"
                                  ? new Date(demand?.kapanisTarihi).toLocaleDateString()
                                  : "-"}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row" >
                                Konu :
                              </th>
                              <td colSpan="2">

                                {demand?.konu}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row" >
                                Açıklama :
                              </th>
                              <td colSpan="2">

                                {demand?.aciklama}
                              </td>
                            </tr>
                            <tr hidden={demand?.musteriCevap === null}>
                              <th scope="row" >
                                Cevap :
                              </th>
                              <td colSpan="2">

                                {demand?.musteriCevap}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="row t-modalFooterDemandDetail ">
                    <div
                      className="col-12"
                      id="id-modalFooter"
                      style={{ color: "rgb(153, 153, 153)" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       

        </div>
      </div>
    );
  }
}
